export function getCarrierLogo(carrierId: string): string | undefined {
  if (!carrierId) return undefined;

  return `https://assets.parcelperform.com/pp-web-app-assets/logo-carriers/square-logo-carries/${carrierId}.png`;
}
